import { useEffect, useRef } from 'react'
import { Typography } from 'shared/ui'
import { Scrollbar } from 'shared/ui/Scrollbar'
import { WidgetItem } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import { SESSION_LIFETIME_OPTIONS } from 'pages/chatbot/ui/UnifiedAgent/ui/AutoFollowUpSection/store/autoFollowUpWidgetStore'
import styles from './styles.module.scss'

type IAutoFollowUpStep2EndSessionProps = {
  focusedIndex: number
  onSelect: (index: number) => void
}

export const AutoFollowUpStep2EndSession = ({
  focusedIndex,
  onSelect,
}: IAutoFollowUpStep2EndSessionProps) => {
  const focusedItemRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    focusedItemRef.current?.scrollIntoView({ block: 'nearest' })
  }, [focusedIndex])

  return (
    <Scrollbar autoHeight autoHeightMax={348}>
      <div className={styles.endSessionList}>
        {SESSION_LIFETIME_OPTIONS.map((item, index) => {
          const isFocused = index === focusedIndex

          return (
            <WidgetItem
              key={item.id}
              ref={isFocused ? focusedItemRef : undefined}
              isFocused={isFocused}
              badgeIndex={index}
              onClick={() => onSelect(index)}
            >
              <Typography variant={'body-rg-regular'} ariaLabel={item.label}>
                {item.label}
              </Typography>
            </WidgetItem>
          )
        })}
      </div>
    </Scrollbar>
  )
}
